import { Checkbox } from 'components/ui/form/Checkbox/index.js';
import { FormControlLabel } from 'components/ui/form/FormControlLabel/index.js';
import type { FormInputProps } from 'components/ui/form/FormInput/index.js';
import { Controller } from 'react-hook-form';

export const FormCheckbox = ({ field, control }: FormInputProps) => {
  return (
    <Controller
      key={`${field.name}`}
      name={field.name}
      control={control}
      render={({ field: { value, onChange } }) => {
        return (
          <FormControlLabel
            label={field?.label ?? ''}
            labelPlacement="end"
            control={(
              <Checkbox
                name={field.name}
                disabled={field?.disabled}
                onChange={e => onChange(e.target.checked)}
                checked={value}
                aria-label={field.inputProps?.['aria-label']}
              />
            )}
          />
        );
      }}
    />
  );
};
